import React from 'react';

import ApplePayButton from 'apps/auth/components/applePay/ApplePayButton';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPrechequePopUp } from 'apps/auth/components/common/send/popups/FixedBottomPrechequePopUp/FixedBottomPrechequePopUp';
import GooglePaySendButton from 'apps/auth/components/googlePay/GooglePaySendButton';

const PreCheckButtons = ({ paymentForm, caption, payAgree }) => {
    return (
        <FixedBottomPrechequePopUp>
            {!paymentForm.fromGooglePay && !paymentForm.fromApplePay && <Button type="button" raised={true} onClick={payAgree} caption={caption} />}
            {paymentForm.fromGooglePay && <GooglePaySendButton />}
            {paymentForm.fromApplePay && <ApplePayButton />}
        </FixedBottomPrechequePopUp>
    );
};
export default PreCheckButtons;
